import { View, Text, StyleSheet, Image } from "@react-pdf/renderer"
import { GGNLocations, HistoricalWeather } from "../../interfaces/intakes.reports"
import dayjs from "dayjs";

interface Props {
    location: GGNLocations
}
export const PDFWeather = ({ location }: Props) => {

    const HistoricalWeather = ({ historical }: { historical: HistoricalWeather }) => {

        return (
            <View style={{ flexDirection: 'row', flex: 1, borderLeft: '1px solid #e0e0e0', justifyContent: 'center', alignItems: 'center' }}>
                <View style={{ alignItems: 'center', marginRight: 12 }}>
                    <Image src={`/assets/weather/${historical.icon}`} style={{ width: "20px" }} />
                    <Text style={[styles.title, { fontSize: '8px' }]}>{dayjs(historical.date).format('DD MMM')}</Text>
                    <Text style={[styles.text, { fontSize: '8px' }]}>{historical.min_temperature}° / {historical.max_temperature}°</Text>
                </View>
                <View>
                    <View style={{ flexDirection: 'row' }}>
                        <Image src={`/assets/weather/humidity.jpg`} style={{ width: "9px", marginRight: 5 }} />
                        <Text style={[styles.text, { fontSize: '8px' }]}>{historical.humidity} <Text style={{ fontSize: '6px' }}>%</Text></Text>
                    </View>
                    <View style={{ flexDirection: 'row' }}>
                        <Image src={`/assets/weather/wind.jpg`} style={{ width: "9px", marginRight: 5 }} />
                        <Text style={[styles.text, { fontSize: '8px' }]}>{historical.wind_speed} <Text style={{ fontSize: '6px' }}>km/h</Text></Text>
                    </View>
                    <View style={{ flexDirection: 'row' }}>
                        <Image src={`/assets/weather/precipitation.jpg`} style={{ width: "9px", marginRight: 5 }} />
                        <Text style={[styles.text, { fontSize: '8px' }]}>{historical.precipitation} <Text style={{ fontSize: '6px' }}>mm</Text></Text>
                    </View>
                    <View style={{ flexDirection: 'row' }}>
                        <Image src={`/assets/weather/radiation.jpg`} style={{ width: "9px", marginRight: 5 }} />
                        <Text style={[styles.text, { fontSize: '8px' }]}>{historical.solar_radiation} <Text style={{ fontSize: '6px' }}>W/m²</Text></Text>
                    </View>
                </View>
            </View>
        )
    };


    return (
        <View style={{ flexDirection: 'row', borderBottom: '1px solid #e0e0e0', alignItems: 'center', paddingVertical: 3 }}>
            <View style={{ width: '10%' }}>
                <Text style={[styles.text]}>{location.city}</Text>
                <Text style={[styles.title]}>{location.country}</Text>
            </View>
            {(location.historical && location.historical.length > 0) &&
                location.historical.map((historical, index) => (
                    <HistoricalWeather key={index} historical={historical} />
                ))
            }
        </View>
    )
}

export const styles = StyleSheet.create({

    title: {
        color: "gray",
        fontSize: "9px",
    },
    text: {
        // fontWeight: 'bold',
        color: '#353644',
        fontSize: "9px",
    },
});